import { render, staticRenderFns } from "./ClubSwitch.vue?vue&type=template&id=e13fa3b4&scoped=true&"
import script from "./ClubSwitch.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ClubSwitch.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ClubSwitch.vue?vue&type=style&index=0&id=e13fa3b4&lang=scss&scoped=true&"
import style1 from "./ClubSwitch.vue?vue&type=style&index=1&id=e13fa3b4&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13fa3b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e13fa3b4')) {
      api.createRecord('e13fa3b4', component.options)
    } else {
      api.reload('e13fa3b4', component.options)
    }
    module.hot.accept("./ClubSwitch.vue?vue&type=template&id=e13fa3b4&scoped=true&", function () {
      api.rerender('e13fa3b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/PaymentInfo/components/PaymentClub/components/ClubSwitch.vue"
export default component.exports